import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SelectStore {

}

export enum SelectStoreKeys {

}
